import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

//import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) => createStyles({

  carouselWrapper: {
    position: 'relative',
    userSelect: 'none',

    width: '100%',
    maxWidth: 'calc(100vw - 32px)', // TODO: Wo kommen die 32px her?

    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100vw - 75px)', // TODO: Wo kommen die 75px her?
    },

    '& .swiper': {
      '& .swiper-button-prev, & .swiper-button-next': {
        '&:after': {
          color: theme.palette.primary.light,
        },
      },
    },
  },

  imageSwiper: {
    height: '450px',
    marginBottom: theme.spacing(4),

    /*...(darkMode ? {
      backgroundColor: 'white',
      borderRadius: '14px',
    }:{}),*/

    '& .swiper-slide, & .swiper-zoom-container': {
      cursor: 'pointer',
      '& > picture': {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& > img, & > picture > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
  },

  imageSwiperModalOnly: {
    touchAction: 'pan-y',

    '& .swiper-slide, & .swiper-zoom-container': {
      touchAction: 'pan-y',
    },
  },

  imageSlide: {
    position: 'relative',
  },

  thumbnailSlide: {
    position: 'relative',
  },

  thumbs: {
    '& .swiper-slide': {
      boxSizing: 'border-box',
      width: '100px',
      height: '70px',
      maxHeight: '70px',
      overflow: 'hidden',
      border: '1px solid',
      borderColor: theme.palette.text.primary,
      cursor: 'pointer',

      /*...(darkMode ? {
        backgroundColor: 'white',
        borderRadius: '9px',
      }:{}),*/

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        backgroundColor: '#fff',
      },

      '&:hover': {
        border: '2px solid',
        padding: 2,
      },
    },

    '& .swiper-slide-thumb-active': {
      border: '2px solid',
    },
  },

}))

export default useStyles
